import { Component, OnInit } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';

@Component({
  selector: 'app-no-studio-modal',
  templateUrl: './no-studio-modal.component.html',
  styleUrls: ['./no-studio-modal.component.scss']
})
export class NoStudioModalComponent implements OnInit {
  constructor(private _ngxSmartModalService: NgxSmartModalService) {}

  ngOnInit(): void {}

  private closeModal() {
    this._ngxSmartModalService.close('noStudioModal');
  }
}
